import styled from '@emotion/styled';

export const SadaEmployeeSelect = styled.div``;
